'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('important-numbers', {
      url: '/important-numbers',
      template: '<important-numbers></important-numbers>',
        authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/directories/important-numbers/important-numbers.routes.js